module.exports = __webpack_public_path__ + "static/img/one_place.efdddf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/one_place.png
// module id = FTb5
// module chunks = 1